<template>
    <div class="container-fluid  mb-5">
        <div class="row">
            <div class="col-md-6">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Complementa estudios que el paciente te bridó</h5>
                        <p>Búsqueda de Estudios
                            <multiselect v-model="selectedEstudio" :options="searchResults" label="nombre_busqueda"
                                track-by="id" placeholder="Ingresa el nombre del estudio"
                                @search-change="searchEstudios" @select="selectEstudio" :loading="isLoading"
                                :clear-on-select="true" :close-on-select="true" :allow-empty="false">
                            </multiselect>
                            <small class="text-muted d-block mt-2">
                                <strong>Nota:</strong> Si no encuentras los estudios que deseas, ve a "Herramientas/Tipos de Estudios", en esa área podrás precargarlos de manera personalizada. 
                            </small>
                        </p>
                        <div class="text-center">
                            <a class="smallText" href="#" @click="fetchResultadosEstudios">Ver mediciones</a>
                        </div>

                        <div v-if="showNuevoResultadoForm" class="mt-3">
                            <h4>Nuevo Resultado de Estudio</h4>
                            <div class="card">
                                <div class="card-body">
                                    <p class="text-muted mt-2">Los campos marcados con <span class="text-danger">*</span> son obligatorios.</p>
                                    <div class="row">
                                        <div class="col-md-12 mb-3">
                                            <label class="form-label">Nombre del Estudio</label>
                                            <input type="text" class="form-control" v-model="nuevoResultado.nombre" disabled>
                                        </div>
                                        <div class="col-md-12 mb-3">
                                            <label class="form-label">Unidad de Medida</label>
                                            <input type="text" class="form-control" v-model="nuevoResultado.unidad" disabled>
                                        </div>
                                        <div class="col-md-12 mb-3">
                                            <label class="form-label">Valor <span class="text-danger">*</span></label>
                                            <input type="number" class="form-control" v-model.number="nuevoResultado.valor" required>
                                        </div>
                                        <div class="col-md-12 mb-3">
                                            <label class="form-label">Fecha de Medición <span class="text-danger">*</span></label>
                                            <input type="datetime-local" class="form-control" v-model="nuevoResultado.fecha_medicion" required>
                                        </div>
                                        <div class="col-md-12 text-center">
                                            <vs-button v-if="userStats !== 1" @click="crearResultadoEstudio" color="rgb(59,222,200)" gradient block>
                                                💾 Guardar Resultado
                                            </vs-button>
                                            <a class="smallText text-center mt-2 d-block" @click="resetNuevoResultadoForm" href="#">Cancelar</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 mt-3" v-if="resultadosEstudios.length > 0">
                <h4>Resultados cargados</h4>
                <p>
                    <small><strong>Nota:</strong> Recuerda que al eliminar registros, estos ya no aparecerán en las gráficas del paciente.</small>
                </p>
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Valor</th>
                            <th>Unidad</th>
                            <th>Fecha de Medición</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="resultado in resultadosEstudios" :key="resultado.id">
                            <td>{{ resultado.nombre }}</td>
                            <td>{{ resultado.valor }}</td>
                            <td>{{ resultado.unidad || 'No especificada' }}</td>
                            <td>{{ new Date(resultado.fecha_medicion).toLocaleDateString() }}</td>
                            <td>

                                <a class="smallText text-center mt-2 d-block" @click="eliminarResultadoEstudio(resultado.id)" href="#">❌ Eliminar</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import Multiselect from 'vue-multiselect';
    var config = require("@/config/api.json");
    const API = config.api;

    export default {
        name: "SearchEstudios",
        components: { Multiselect },
        data() {
            return {
                userStats: null,
                searchValue: '',
                searchResults: [],
                selectedEstudio: null,
                isLoading: false,
                showNuevoResultadoForm: false,
                nuevoResultado: {
                    nombre: '',
                    unidad: '',
                    valor: null,
                    fecha_medicion: ''
                },
                resultadosEstudios: [] // Almacena los resultados obtenidos
            };
        },
        mounted() {
            this.fetchResultadosEstudios();
             setTimeout(() => {
                this.userStats = this.getUserStatus();
            }, 500);
        },
        props: {
            mainId: {
                type: [String, Number],
                required: true
            },
            paciente: {
                type: Object,
                required: true
            },
            consulta_id: {
                type: [String, Number],
                required: true
            }
        },
        methods: {
            async searchEstudios(query) {
                console.log('Buscando estudios...', this.mainId, query);
                if (query.trim() === '') {
                    this.searchResults = [];
                    return;
                }
                this.isLoading = true;
                try {
                    const response = await axios.post(`${API}/busqueda_tipos_estudios`, {
                        params: {
                            searchValue: query,
                            personal_medico_id: this.mainId
                        }
                    });
                    console.log(response.data);
                    this.searchResults = response.data;
                } catch (error) {
                    console.error(error);
                    this.notify('error', `Error: ${error.message}`);
                } finally {
                    this.isLoading = false;
                }
            },
            selectEstudio(estudio) {
                console.log(estudio);
                this.searchResults = [];
                this.$emit('select', estudio);
                this.nuevoResultado = {
                    nombre: estudio.nombre,
                    unidad: estudio.unidad || '',
                    valor: null,
                    fecha_medicion: new Date().toISOString().slice(0, 16) // Precargar con la fecha actual en formato ISO
                };
                this.showNuevoResultadoForm = true;
                setTimeout(() => {
                    this.selectedEstudio = null;
                }, 1000);
            },
            async crearResultadoEstudio() {
                if (!this.vEmpty(this.nuevoResultado.nombre?.toString(), 'Nombre del Estudio')) return;
                if (!this.vEmpty(this.nuevoResultado.valor?.toString(), 'Valor')) return;
                if (!this.vEmpty(this.nuevoResultado.fecha_medicion?.toString(), 'Fecha de Medición')) return;

                const postData = {
                    paciente_id: this.paciente.paciente_id || this.paciente.id,
                    consulta_id: this.consulta_id,
                    nombre: this.nuevoResultado.nombre,
                    valor: this.nuevoResultado.valor,
                    unidad: this.nuevoResultado.unidad,
                    fecha_medicion: this.nuevoResultado.fecha_medicion
                };

                try {
                    const response = await axios.post(`${API}/crear_resultado_estudio`, postData);
                    if (response.data.status === 'success') {
                        await this.callAudit(this.mainId, "CREAR", "resultados_estudios", this.consulta_id, "Se crea resultado de estudio");

                        this.notify('success', 'Resultado de estudio creado exitosamente.');
                        this.resetNuevoResultadoForm();
                        this.fetchResultadosEstudios();
                    }
                } catch (error) {
                    console.error(error);
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                }
            },
            resetNuevoResultadoForm() {
                this.nuevoResultado = {
                    nombre: '',
                    unidad: '',
                    valor: null,
                    fecha_medicion: ''
                };
                this.showNuevoResultadoForm = false;
            },
            async fetchResultadosEstudios() {
                this.resultadosEstudios = [];
                try {
                    const response = await axios.get(`${API}/obtener_resultados_estudios`, {
                        params: {
                            paciente_id: this.paciente.paciente_id,
                            consulta_id: this.consulta_id
                        }
                    });

                    if (response.data.status === 'success' && response.data.data.length > 0) {
                        this.resultadosEstudios = response.data.data;
                    } else {
                        this.resultadosEstudios = [];
                        this.notify('info', 'No existen registros cargados aún.');
                    }
                } catch (error) {
                    console.error(error);
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                }
            },
            async eliminarResultadoEstudio(id) {
                try {
                    const response = await axios.delete(`${API}/borrar_resultado_estudio/${id}`);
                    if (response.data.status === 'success') {
                        this.notify('success', 'Resultado de estudio eliminado exitosamente.');
                        await this.callAudit(this.mainId, "BORRAR", "resultados_estudios", id, "Se elimina resultado de estudio");


                        this.fetchResultadosEstudios();
                    } else {
                        this.notify('error', 'Error al eliminar el resultado de estudio.');
                    }
                } catch (error) {
                    console.error(error);
                    this.notify('error', `Error: ${error.response?.data?.message || error.message}`);
                }
            }
        }
    };
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
    .autocomplete-results {
        border: 1px solid #ccc;
        max-height: 200px;
        overflow-y: auto;
        list-style-type: none;
        padding: 0;
        margin: 0;
    }

    .autocomplete-results li {
        padding: 8px;
        cursor: pointer;
    }

    .autocomplete-results li:hover {
        background-color: #f0f0f0;
    }
</style>